<div class="fee-schedule-container" *ngIf="!isLoading" data-cy="fee-schedule-main-container">
  <div class="side-list" data-cy="fee-schedule-main-side-list">
    <div style="display: flex; flex-basis: fit-content; margin-left: 8px;" data-cy="fee-schedule-main-title-container">
      <span class="configuration-section-title" data-cy="fee-schedule-main-title">Fee Schedules</span>
    </div>
    <!--NAVIGATION-->
    <app-fee-schedule-list style="flex: 1; overflow-y: hidden;"
      [selectedDocFeeScheduleID]="selectedDocFeeScheduleID"
      [feeScheduleList]="feeScheduleList"
      [defaultDoctorId]="doctorId"
      [selectedFeeScheduleId]="selectedFeeScheduleID"
      (selectFeeSchedule)="setSelectedSchedule($event)"
      (selectDocFeeSchedule)="setSelectedDocSchedule($event)"
      data-cy="fee-schedule-main-list-component"></app-fee-schedule-list>
  </div>
  <!--MAIN CONTENT-->
  <div class="fee-schedule-main-list" data-cy="fee-schedule-main-content">
    <app-fee-schedule-edit-items
      [selectedDocFeeScheduleID]="selectedDocFeeScheduleID"
      [feeSchedule]="activeFeeSchedule"
      data-cy="fee-schedule-main-edit-items">
    </app-fee-schedule-edit-items>
  </div>
</div>
<div *ngIf="isLoading" class="spinner-holder" data-cy="fee-schedule-main-loading">
  <mat-spinner data-cy="fee-schedule-main-spinner"></mat-spinner>
</div>
